import { Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { EntityStatus } from '@core';
import { DeviceData, DeviceIncidentRule } from '@devices';
import { IncidentSeverity } from '@models';
import { TIPPY_REF } from '@ngneat/helipopper';

import { getRuleIncidentCountBySeverity } from '../../../../../incidents/src/lib/helpers';

@Component({
  imports: [RouterLink],
  selector: 'avs-li-device-popover',
  standalone: true,
  templateUrl: './device-popover.component.html',
})
export class DevicePopoverComponent {
  protected tippy = inject(TIPPY_REF);
  protected locationId = '';
  protected floorId = '';
  protected device = signal<DeviceData | null>(null);
  protected deviceRule = signal<DeviceIncidentRule | null>(null);
  protected allowNavigation = true;
  protected readonly eEntityStatus = EntityStatus;
  protected readonly eIncidentSeverity = IncidentSeverity;
  protected hide: () => void;
  protected id = computed(() => this.deviceRule()?.deviceId || this.device()?.id);
  protected name = computed(() => this.deviceRule()?.friendlyName || this.device()?.friendlyName);
  protected status = computed(() => this.deviceRule()?.status || this.device()?.status);
  protected incidents = computed(() => {
    const rule = this.deviceRule();

    if (rule?.incidents) {
      return getRuleIncidentCountBySeverity(rule.incidents);
    }

    return this.device()?.incidentCountBySeverity;
  });
  protected severity = computed(() => this.deviceRule()?.severity);
  protected deviceName = computed(() => this.deviceRule()?.deviceName);

  constructor() {
    const { locationId, floorId, details, allowNavigation = true } = this.tippy.data;

    this.locationId = locationId;
    this.floorId = floorId;
    if (details?.deviceId) {
      this.deviceRule.set(details);
    } else {
      this.device.set(details);
    }

    this.allowNavigation = allowNavigation;
    this.hide = this.tippy.hide;
  }
}
